import type { AdminBundle } from '../ru/admin';

export const adminEn: AdminBundle = {
  languageLabel: 'Language',
};
